module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/amex-86f2fea6.svg";